import { render } from "./AHJPage.vue?vue&type=template&id=755398a2&scoped=true"
import script from "./AHJPage.vue?vue&type=script&lang=js"
export * from "./AHJPage.vue?vue&type=script&lang=js"

import "./AHJPage.vue?vue&type=style&index=0&id=755398a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755398a2"]])

export default __exports__